import { AirportShuttle, DirectionsWalk, Login, Logout, RocketLaunch, ToggleOff, ToggleOn } from '@mui/icons-material'
import { SxProps, Theme } from '@mui/material'
import { cyan, green, orange, red, yellow } from '@mui/material/colors'
import { ActivityType } from '../../types/models'

export interface ActivityIconProps {
  type: ActivityType
  sx?: SxProps<Theme>
}

/**
 * Display an icon for an appliance type.
 */
export const ActivityIcon = (props: ActivityIconProps): JSX.Element => {
  const { type } = props

  const table: Partial<Record<ActivityType, string>> = {
    MANUAL_OFF: orange[800],
    MANUAL_ON: orange[800],
    RELAY_OFF: red[700],
    RELAY_ON: green[700],
    VISIT: cyan[600],
    LOGIN: cyan[600],
    LOGOUT: cyan[600],
    DEVBOOT: yellow[400],
  } as const

  const color = type in table ? table[type] : 'inherit'

  const sx = {
    color,
    ...props.sx
  }

  switch (type) {
    case 'RELAY_ON':
      return <ToggleOn sx={sx} />
    case 'RELAY_OFF':
      return <ToggleOff sx={sx} />
    case 'MANUAL_ON':
      return <DirectionsWalk sx={sx} />
    case 'MANUAL_OFF':
      return <AirportShuttle sx={sx} />
    case 'LOGIN':
    case 'VISIT':
      return <Login sx={sx} />
    case 'LOGOUT':
      return <Logout sx={sx} />
    case 'DEVBOOT':
      return <RocketLaunch sx={sx} />
    default:
      return <></>
  }
}
